import Portico from '@ordernext/networking-stadium/portico'
import Stadium from '@ordernext/networking-stadium/stadium'

const configurePortico = () => {
  Portico.config = {
    baseURL: process.env.REACT_APP_OIDC_ISSUER,
  }
}

const configureStadium = () => {
  Stadium.config = {
    baseURL: process.env.REACT_APP_BASE_URL,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
    },
  }
}

const configureServices = () => {
  const services = [configurePortico, configureStadium]
  services.forEach(service => service())
}

export default configureServices
